// extracted by mini-css-extract-plugin
export default {"text":"text__6b1ce7c7","link":"link__6b1ce7c7"};